module.exports = __webpack_public_path__ + "static/media/wheelchair.11451504.svg";